import React from "react";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import App from "./App";
import "./styles/Menu.css";  
import { createRoot } from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";


const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

createRoot(document.getElementById("root")).render(
  <GoogleOAuthProvider clientId={CLIENT_ID}>
    <App />
  </GoogleOAuthProvider>
);
